import { useState } from 'react';

export function useRandomNumber(multiplier: number) {
  const [randomNumber, setRandomNumber] = useState(Math.floor(Math.random() * multiplier));
  return randomNumber;
}
